import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { makeNoLaterThenValidator } from 'CorePackage/MainModule/validators/isNoLaterThen';
import { makeNoSoonerThenValidator } from 'CorePackage/MainModule/validators/isNoSoonerThan';
import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';
import { getActEventProtocolValidator } from 'KnmErknmPackage/MainModule/common/getActEventProtocolValidator';

export const getDecisionActEventValidate = (
  item: IKnmErknmFormEvent,
  holdingDateTime?: string,
  isInteractionCategoryOrInspectorRequired?: boolean,
  eventsDecision?: IKnmErknmFormEvent[],
): FormErrors<IKnmErknmFormEvent> => {
  const isWithoutAction = item.type?.label === 'Осуществляется без действия';

  let isShowVksFields: boolean | undefined;
  let knmEvent: IKnmErknmFormEvent | undefined;

  if (item.type?.label) {
    knmEvent = eventsDecision?.find(i => i.type?.title === item.type?.label);

    isShowVksFields = knmEvent?.interactionCategory && knmEvent.interactionCategory.id === 1;
  }

  return {
    type: makeRequired('Поле не может быть пустым')(item.type),
    inspectors:
      !isWithoutAction && isInteractionCategoryOrInspectorRequired && !item.actionNotPerformed
        ? item.inspectors?.map(inspector => ({
            fullName: makeRequired('Поле не может быть пустым')(inspector?.fullName?.value),
          }))
        : undefined,
    startDate: item.actionNotPerformed
      ? undefined
      : composeValidators(
          makeNoLaterThenValidator('Дата начала не должна быть позже даты окончания', () => item.stopDate),
          makeRequired('Поле не может быть пустым', () => isWithoutAction),
          makeNoSoonerThenValidator(
            'Дата начала действия в акте должна быть больше или равна дате начала проведения КНМ в акте',
            () => holdingDateTime,
          ),
        )(item.startDate),
    stopDate: item.actionNotPerformed
      ? undefined
      : composeValidators(
          makeNoSoonerThenValidator('Дата окончания не должна быть раньше даты начала', () => item.startDate),
          makeRequired('Поле не может быть пустым', () => isWithoutAction),
          makeNoSoonerThenValidator(
            'Дата окончания должна быть больше или равна дате начала осуществленного действия',
            () => holdingDateTime,
          ),
        )(item.stopDate),
    linkVks:
      !item.actionNotPerformed && isShowVksFields ? makeRequired('Поле не может быть пустым')(item.linkVks) : undefined,
    protocol: getActEventProtocolValidator(item),
  };
};
